import {MainCategory} from "@pages/modal/mainCategory";

export interface SubCategory {
    subCatId: number
    subCatName: string
    activeStatus: string
    createdBy: string
    modifiedBy: string
    createdAt: number
    modifiedAt: number
    mainProductCategory: MainCategory
    subcatImage: string
}

export class SubCategoryClass {
    subCatId: number
    subCatName: string
    activeStatus: string
    createdBy: string
    modifiedBy: string
    createdAt: number
    modifiedAt: number
    mainProductCategory: MainCategory
    subcatImage: string
}
